import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIonRouter } from '@ionic/react';
import Icon from './Icon';
import { haptic } from '../utils/haptics';

interface BackHeaderProps {
  title: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
}

const BackHeader: React.FC<BackHeaderProps> = ({ title, subtitle, rightContent }) => {
  const history = useHistory();
  const ionRouter = useIonRouter();

  return (
    <header
      className="fh-back-header"
      role="banner"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        paddingTop: 'env(safe-area-inset-top, 0px)',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 8,
        background: 'rgba(15,25,35,0.78)',
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        minHeight: 44,
        borderBottom: '0.33px solid rgba(84,84,88,0.65)',
      }}
    >
      <button
        aria-label="Go back"
        onClick={() => { void haptic('light'); if (ionRouter.canGoBack()) history.goBack(); else history.replace('/app/home'); }}
        className="fh-header-back-btn"
        style={{
          background: 'var(--fh-overlay-strong)',
          border: '1.5px solid var(--fh-overlay-strong)',
          borderRadius: '50%',
          width: 44,
          height: 44,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          WebkitTapHighlightColor: 'transparent',
          transition: 'background 0.15s, transform 0.15s',
        }}
      >
        <Icon name="arrow_back_ios" size={20} color="var(--fh-dark-text)" />
      </button>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1
          style={{
            fontFamily: 'var(--fh-font-headline)',
            fontSize: 'var(--fh-text-body)',
            fontWeight: 700,
            color: 'var(--fh-dark-text)',
            letterSpacing: '-0.01em',
            margin: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p style={{
            fontSize: 'var(--fh-text-caption1)',
            fontWeight: 500,
            color: 'var(--fh-dark-text-secondary)',
            margin: '1px 0 0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {rightContent && <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>{rightContent}</div>}
    </header>
  );
};

export default BackHeader;
